import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query"
import api from "@/lib/axios"
import FormHeader from "@/components/FormHeader"
import { Button } from "@/components/ui/button"
import { Label } from "@/components/ui/label"
import { useState } from "react"
import { Loader2 } from "lucide-react"
import toast from "react-hot-toast"
import { AxiosError } from "axios"
import { getListPeriode } from "@/services/getData"
import { MultiSelect } from "@/components/ui/multi-select"
import { Periode } from "@/types"
import { MdOutlineSync } from "react-icons/md"

const postData = async (newData: { id_sys_periode: string }) => {
  const response = await api.post(
    "/setting/verifikator-butawarna/rekap",
    newData
  )
  return response.data
}

export default function Form({ closeModal }: { closeModal: () => void }) {
  const { data: dataPeriode } = useQuery({
    queryKey: ["listPeriode"],
    queryFn: () => getListPeriode(),
    select: (data) =>
      data?.map((periode: Periode) => ({
        label: `${periode.jalur_jenis?.nama_jalur_jenis}-${periode.tahun} Gelombang ${periode.gelombang}`,
        value: periode.id_sys_periode,
      })),
  })

  const [selectedPeriodes, setSelectedPeriodes] = useState<string[]>([])

  const queryClient = useQueryClient()
  const { mutate, isPending } = useMutation({
    mutationFn: postData,
    onSuccess: (data) => {
      queryClient.invalidateQueries({
        queryKey: ["listRekapPesertaButawarna"],
      })
      closeModal()
      toast.success(data?.message || "Success.")
    },
    onError: (error: AxiosError) => {
      const err = error as AxiosError<{ message?: string }>
      toast.error(
        err?.response?.data?.message || "An unexpected error occurred."
      )
    },
  })

  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault()
    mutate({ id_sys_periode: selectedPeriodes.join(",") })
  }

  return (
    <form onSubmit={handleSubmit} className="flex flex-col gap-y-3">
      <FormHeader
        icon={<MdOutlineSync />}
        title={"Generate Rekap Pesesrta Cek Butawarna"}
      />
      <div>
        <Label>Periode</Label>
        <MultiSelect
          options={dataPeriode || []}
          onValueChange={(value) => {
            setSelectedPeriodes(value)
          }}
          defaultValue={selectedPeriodes}
          placeholder="Pilih Periode"
          variant="inverted"
          animation={2}
          maxCount={3}
        />
      </div>

      <Button className="mt-3 flex items-center gap-3" disabled={isPending}>
        {isPending ? (
          <>
            <Loader2 className="w-4 h-4 mr-1 animate-spin" />
            Processing...
          </>
        ) : (
          "Generate"
        )}
      </Button>
    </form>
  )
}
